<template>
  <div class="studentStatistics">
    <div class="module">
      <div class="item" style="width: 24.5%">
        <div class="title">学生数据统计</div>
        <div class="content">
          <div class="studentNumber">
            <div v-for="item in studentNumberData">
              <p class="num">{{item.rs}}人</p>
              <p class="text">{{item.ryfl}}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="item" style="width: 24.5%">
        <div class="title">男女比例</div>
        <div class="content" id="sexRatio">
        </div>
      </div>
      <div class="item" style="width: 24.5%">
        <div class="title">分年级</div>
        <div class="content" id="grade">
        </div>
      </div>
      <div class="item" style="width: 24.5%">
        <div class="title">分学制</div>
        <div class="content" id="schoolSystem">
        </div>
      </div>
    </div>
    <div class="module">
      <div class="item" style="width: 39.5%">
        <div class="title">民族分布</div>
        <div class="content" id="nationStudent">
        </div>
      </div>
      <div class="item" style="width: 59.5%">
        <div class="title">各专业学生数</div>
        <div class="content" id="majorStudent"></div>
      </div>
    </div>
    <div class="module">
      <div class="item" style="width: 39.5%">
        <div class="title">在校生生源分布</div>
        <div class="content">
          <chinaMap :mapData="mapData"></chinaMap>
        </div>
      </div>
      <div class="item" style="width: 59.5%">
        <div class="title">省内生源学生</div>
        <div class="content" id="provinceStudent">

        </div>
      </div>
    </div>
    <div class="module">
      <div class="item" style="width: 49.5%">
        <div class="title">本周各系部学生请销假人数</div>
        <div class="content" id="leaveStudent"></div>
      </div>
      <div class="item" style="width: 49.5%">
        <div class="title">各专业毕业学生情况</div>
        <div class="content" id="graduateStudent"></div>
      </div>
    </div>
  </div>
</template>

<script>
  import chinaMap from "./map";
  import axios from "axios";
  import apiConfig from "../../common/js/api_config";

  export default {
    name: "studentStatistics",
    components: {chinaMap},
    data() {
      return {
        staffColor: ['#1F89DF', '#49A3EC', '#6FB7F2', '#91C7AE', '#A2A860', '#91C7AE', '#EEC714', '#EEB814', '#6ABD9D'],
        studentNumberData: [],
        sexRatioData: [
          {
            name: '男',
            value: 100
          },
          {
            name: '女',
            value: 120
          }
        ],
        gradeData: [
          {
            name: '2022',
            value: 5000
          },
          {
            name: '2021',
            value: 3000
          }
        ],
        schoolSystemData: [
          {
            name: '2年',
            value: 10000,
          },
          {
            name: '3年',
            value: 20000
          }
        ],
        nationStudentData: [
          {
            name: '汉族',
            value: 5000
          },
          {
            name: '回族',
            value: 3000
          }
        ],
        mapData: []
      }
    },
    methods: {
      async getStudentNumberData() {
        let resp = await axios.post(apiConfig.REQUEST_URL + '/shall/f_xs_xsrstj')
        this.studentNumberData = resp.data.data
      },
      // 男女比例
      async getSexRatioData() {
        let resp = await axios.post(apiConfig.REQUEST_URL + '/shall/f_xs_xsxbtj')
        let data = resp.data.data
        data.map(item => {
          item.name = item.xb
          item.value = item.rs
        })
        this.drawSexRatio(data)
      },
      drawSexRatio(data) {
        let option = {
          tooltip: {
            trigger: 'item',
            backgroundColor: 'rgba(31, 137, 223, 0.7)',
            formatter: '{b} <br/>{a}: {c} ({d}%)'
          },
          legend: {
            orient: 'vertical',
            right: 20,
            top: 42,
            itemWidth: 10,
            itemHeight: 10,
            data: data.map(item => item.name)
          },
          series: [
            {
              name: '人数',
              type: 'pie',
              center: ['50%', '50%'],
              radius: ['45%', '65%'],
              emphasis: {
                label: {
                  show: true,
                  fontSize: '14',
                  fontWeight: 'bold'
                }
              },
              color: this.staffColor,
              data: data
            }
          ]
        };
        this.sexRatioBox.setOption(option)
      },
      // 分年级
      async getGradeData() {
        let resp = await axios.post(apiConfig.REQUEST_URL + '/shall/f_xs_xsnjtj')
        let data = resp.data.data
        data.map(item => {
          item.name = item.nj
          item.value = item.rs
        })
        this.drawGrade(data)
      },
      drawGrade(data) {
        let option = {
          tooltip: {
            trigger: 'item',
            backgroundColor: 'rgba(31, 137, 223, 0.7)',
            formatter: '{b} <br/>{a}: {c} ({d}%)'
          },
          legend: {
            orient: 'vertical',
            right: 20,
            top: 42,
            itemWidth: 10,
            itemHeight: 10,
            data: data.map(item => item.name)
          },
          series: [
            {
              name: '人数',
              type: 'pie',
              center: ['50%', '50%'],
              radius: ['45%', '65%'],
              emphasis: {
                label: {
                  show: true,
                  fontSize: '14',
                  fontWeight: 'bold'
                }
              },
              color: this.staffColor,
              data: data
            }
          ]
        };
        this.gradeBox.setOption(option)
      },
      // 分学制
      async getSchoolSystemData() {
        let resp = await axios.post(apiConfig.REQUEST_URL + '/shall/f_xs_xsxztj')
        let data = resp.data.data
        data.map(item => {
          item.name = item.xz
          item.value = item.rs
        })
        this.drawSchoolSystem(data)
      },
      drawSchoolSystem(data) {
        let option = {
          tooltip: {
            trigger: 'item',
            backgroundColor: 'rgba(31, 137, 223, 0.7)',
            formatter: '{b} <br/>{a}: {c} ({d}%)'
          },
          legend: {
            orient: 'vertical',
            right: 20,
            top: 42,
            itemWidth: 10,
            itemHeight: 10,
            data: data.map(item => item.name)
          },
          series: [
            {
              name: '人数',
              type: 'pie',
              center: ['50%', '50%'],
              radius: ['45%', '65%'],
              emphasis: {
                label: {
                  show: true,
                  fontSize: '14',
                  fontWeight: 'bold'
                }
              },
              color: this.staffColor,
              data: data
            }
          ]
        };
        this.schoolSystemBox.setOption(option)
      },
      // 民族分布
      async getNationStudentData() {
        let resp = await axios.post(apiConfig.REQUEST_URL + '/shall/f_xs_xsmztj')
        let data = resp.data.data
        data.map(item => {
          item.name = item.mz
          item.value = item.rs
        })
        this.drawNationStudent(data)
      },
      drawNationStudent(data) {
        let option = {
          tooltip: {
            trigger: 'item',
            backgroundColor: 'rgba(31, 137, 223, 0.7)',
            formatter: '{b} <br/>{a}: {c} ({d}%)'
          },
          legend: {
            show: true,
            orient: 'vertical',
            right: 20,
            top: 0,
            itemWidth: 10,
            itemHeight: 10,
            data: data.map(item => item.name)
          },
          series: [
            {
              name: '人数',
              type: 'pie',
              center: ['50%', '50%'],
              radius: ['45%', '65%'],
              emphasis: {
                label: {
                  show: true,
                  fontSize: '14',
                  fontWeight: 'bold'
                }
              },
              color: this.staffColor,
              data: data
            }
          ]
        };
        this.nationStudentBox.setOption(option)
      },
      // 各专业学生数
      async getMajorStudentData() {
        let resp = await axios.post(apiConfig.REQUEST_URL + '/shall/f_xs_zxsfnjgzyxss')
        let dataArray = []
        let zyArray = Array.from(new Set(resp.data.data.map(item => item.zymc)))
        let yearArray = Array.from(new Set(resp.data.data.map(item => item.nj))).sort()
        yearArray.forEach(item => {
          dataArray.push({
            name: item,
            type: 'bar',
            data: new Array(zyArray.length),
            itemStyle: {
              barBorderRadius: [0, 0, 0, 0],
            },
            barMaxWidth: 20,
          })
        })
        dataArray.forEach(dataItem => {
          resp.data.data.forEach(item => {
            if (dataItem.name === item.nj) {
              dataItem.data[zyArray.findIndex(element => element === item.zymc)] = item.rs
            }
          })
        })
        this.drawMajorStudent(zyArray, dataArray)
      },
      drawMajorStudent(zyArray, dataArray) {
        let option = {
          color: this.staffColor,
          tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgba(31, 137, 223, 0.7)',
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
              type: 'none'        // 默认为直线，可选为：'line' | 'shadow'
            },
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '4%',
            top: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              data: zyArray,
              axisLine: {
                lineStyle: {
                  color: '#ECF0F7'
                }
              },
              axisTick: {
                alignWithLabel: true
              },
              axisLabel: {
                show: true,
                textStyle: {
                  color: '#666666',
                  fontSize: 14
                },
                interval: 0
              },

            }
          ],
          yAxis: [
            {
              type: 'value',
              axisLabel: {
                show: true,
                textStyle: {
                  color: '#666666',
                  fontSize: 14
                },
                interval: 0
              },
              axisLine: {
                lineStyle: {
                  color: '#ECF0F7'
                }
              },
              splitLine: {
                show: true,
                lineStyle: {
                  color: ['#ECF0F7'],
                  width: 1,
                  type: 'solid'
                }
              }
            }
          ],
          dataZoom: [
            {
              show: true,
              start: 0,
              end: 10
            },
            {
              type: 'inside',
              start: 0,
              end: 10
            },
          ],
          series: dataArray
        };
        this.majorStudentBox.setOption(option)
      },
      // 全国生源学生
      async getCountryStudentData() {
        let resp = await axios.post(apiConfig.REQUEST_URL + '/shall/f_xs_zxssyfb_qg')
        console.log(resp);
        let data = []

        function setName(name) {
          let str
          if (name.indexOf('省') > -1) {
            str = name.slice(0, name.indexOf('省'))
          }
          if (name.indexOf('市') > -1) {
            str = name.slice(0, name.indexOf('市'))
          }
          if (name.indexOf('自治区') > -1) {
            if (name.indexOf('内蒙古') > -1) {
              str = '内蒙古'
            } else {
              str = name.slice(0, 2)
            }
          }
          return str
        }

        resp.data.data.map(item => {
          data.push({
            name: setName(item.sf),
            value: item.rs
          })
        })
        console.log(data);
        this.mapData = data
      },
      // 省内生源学生
      async getProvinceStudentData() {
        let resp = await axios.post(apiConfig.REQUEST_URL + '/shall/f_xs_zxssyfb_sn')
        let dsArray = []
        let rsArray = []
        resp.data.data.map(item => {
          dsArray.push(item.ds)
          rsArray.push(item.rs)
        })
        this.drawProvinceStudent(dsArray, rsArray)
      },
      drawProvinceStudent(dsArray, rsArray) {
        let option = {
          color: this.staffColor,
          tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgba(31, 137, 223, 0.7)',
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
              type: 'none'        // 默认为直线，可选为：'line' | 'shadow'
            },
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '4%',
            top: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              data: dsArray,
              axisLine: {
                lineStyle: {
                  color: '#ECF0F7'
                }
              },
              axisTick: {
                alignWithLabel: true
              },
              axisLabel: {
                show: true,
                textStyle: {
                  color: '#666666',
                  fontSize: 14
                },
                interval: 0
              },

            }
          ],
          yAxis: [
            {
              type: 'value',
              axisLabel: {
                show: true,
                textStyle: {
                  color: '#666666',
                  fontSize: 14
                },
                interval: 0
              },
              axisLine: {
                lineStyle: {
                  color: '#ECF0F7'
                }
              },
              splitLine: {
                show: true,
                lineStyle: {
                  color: ['#ECF0F7'],
                  width: 1,
                  type: 'solid'
                }
              }
            }
          ],
          series: [
            {
              name: '人数',
              type: 'bar',
              barWidth: '60%',
              data: rsArray,
              itemStyle: {
                barBorderRadius: [0, 0, 0, 0],
              },
              barMaxWidth: 20
            }
          ]
        };
        this.provinceStudentBox.setOption(option)
      },
      // 请假学生
      async getLeaveStudentData() {
        let resp = await axios.post(apiConfig.REQUEST_URL + '/shall/f_xs_bzgxbxsqxjrs')
        let dataArray = []
        let zyArray = Array.from(new Set(resp.data.data.map(item => item.dwmc)))
        let yearArray = Array.from(new Set(resp.data.data.map(item => item.nj))).sort()
        yearArray.forEach(item => {
          dataArray.push({
            name: item,
            type: 'bar',
            barWidth: '60%',
            data: new Array(zyArray.length),
            itemStyle: {
              barBorderRadius: [0, 0, 0, 0],
            },
            barMaxWidth: 20,
          })
        })
        dataArray.forEach(dataItem => {
          resp.data.data.forEach(item => {
            if (dataItem.name === item.nj) {
              dataItem.data[zyArray.findIndex(element => element === item.dwmc)] = item.qjrs
            }
          })
        })
        this.drawLeaveStudent(zyArray, dataArray)
      },
      drawLeaveStudent(zyArray, dataArray) {
        let option = {
          color: this.staffColor,
          tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgba(31, 137, 223, 0.7)',
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
              type: 'none'        // 默认为直线，可选为：'line' | 'shadow'
            },
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '4%',
            top: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              data: zyArray,
              axisLine: {
                lineStyle: {
                  color: '#ECF0F7'
                }
              },
              axisTick: {
                alignWithLabel: true
              },
              axisLabel: {
                show: true,
                textStyle: {
                  color: '#666666',
                  fontSize: 14
                },
                interval: 0
              },

            }
          ],
          yAxis: [
            {
              type: 'value',
              axisLabel: {
                show: true,
                textStyle: {
                  color: '#666666',
                  fontSize: 14
                },
                interval: 0
              },
              axisLine: {
                lineStyle: {
                  color: '#ECF0F7'
                }
              },
              splitLine: {
                show: true,
                lineStyle: {
                  color: ['#ECF0F7'],
                  width: 1,
                  type: 'solid'
                }
              }
            }
          ],
          dataZoom: [
            {
              show: true,
              start: 0,
              end: 50
            },
            {
              type: 'inside',
              start: 0,
              end: 50
            },

          ],
          series: dataArray
        };
        this.leaveStudentBox.setOption(option)
      },
      // 毕业学生
      async getGraduateStudentData() {
        let resp = await axios.post(apiConfig.REQUEST_URL + '/shall/f_xs_gzybyxsqk')
        let dataArray = []
        let zyArray = Array.from(new Set(resp.data.data.map(item => item.zymc)))
        let yearArray = Array.from(new Set(resp.data.data.map(item => item.byqx))).sort()
        yearArray.forEach(item => {
          dataArray.push({
            name: item,
            type: 'bar',
            data: new Array(zyArray.length),
            itemStyle: {
              barBorderRadius: [0, 0, 0, 0],
            },
            barMaxWidth: 20,
          })
        })
        dataArray.forEach(dataItem => {
          resp.data.data.forEach(item => {
            if (dataItem.name === item.byqx) {
              dataItem.data[zyArray.findIndex(element => element === item.zymc)] = item.rs
            }
          })
        })
        this.drawGraduateStudent(zyArray, dataArray)
      },
      drawGraduateStudent(zyArray, dataArray) {
        let option = {
          color: this.staffColor,
          tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgba(31, 137, 223, 0.7)',
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
              type: 'none'        // 默认为直线，可选为：'line' | 'shadow'
            },
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '4%',
            top: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              data: zyArray,
              axisLine: {
                lineStyle: {
                  color: '#ECF0F7'
                }
              },
              axisTick: {
                alignWithLabel: true
              },
              axisLabel: {
                show: true,
                textStyle: {
                  color: '#666666',
                  fontSize: 14
                },
                interval: 0
              },

            }
          ],
          yAxis: [
            {
              type: 'value',
              axisLabel: {
                show: true,
                textStyle: {
                  color: '#666666',
                  fontSize: 14
                },
                interval: 0
              },
              axisLine: {
                lineStyle: {
                  color: '#ECF0F7'
                }
              },
              splitLine: {
                show: true,
                lineStyle: {
                  color: ['#ECF0F7'],
                  width: 1,
                  type: 'solid'
                }
              }
            }
          ],
          dataZoom: [
            {
              show: true,
              start: 0,
              end: 10
            },
            {
              type: 'inside',
              start: 0,
              end: 10
            },

          ],
          series: dataArray
        };
        this.graduateStudentBox.setOption(option)
      }
    },
    mounted() {
      this.sexRatioBox = this.$echarts.init(document.getElementById('sexRatio'))
      this.gradeBox = this.$echarts.init(document.getElementById('grade'))
      this.schoolSystemBox = this.$echarts.init(document.getElementById('schoolSystem'))
      this.majorStudentBox = this.$echarts.init(document.getElementById('majorStudent'))
      this.nationStudentBox = this.$echarts.init(document.getElementById('nationStudent'))
      this.provinceStudentBox = this.$echarts.init(document.getElementById('provinceStudent'))
      this.leaveStudentBox = this.$echarts.init(document.getElementById('leaveStudent'))
      this.graduateStudentBox = this.$echarts.init(document.getElementById('graduateStudent'))
      this.getStudentNumberData()

      this.getSexRatioData()
      this.getGradeData()
      this.getSchoolSystemData()
      this.getNationStudentData()
      this.getMajorStudentData()
      this.getCountryStudentData()
      this.getProvinceStudentData()
      this.getLeaveStudentData()
      this.getGraduateStudentData()
      window.addEventListener('resize', () => {
        this.sexRatioBox.resize()
        this.gradeBox.resize()
        this.schoolSystemBox.resize()
        this.majorStudentBox.resize()
        this.nationStudentBox.resize()
        this.provinceStudentBox.resize()
        this.leaveStudentBox.resize()
        this.graduateStudentBox.resize()
      })
    }
  }
</script>

<style lang="stylus" scoped>
  .studentStatistics
    width 100%
    color #333

    .module
      width 100%
      height 350px
      margin-top 25px
      display flex
      justify-content space-between

      .item
        height 100%
        background #fff
        border-radius 10px
        overflow hidden

        .title
          width 100%
          height 20%
          display flex
          align-items center
          justify-content center
          font-size 18px
          font-weight bold

        .content
          width 100%
          height 80%

          .studentNumber
            width 100%
            height 100%
            display flex
            align-items center
            justify-content space-around

            div
              display flex
              flex-direction column
              justify-content center
              align-items center

              .num
                font-size 26px

              .text
                font-size 18px
                margin-top 25px
</style>


// WEBPACK FOOTER //
// src/components/datanalysis/studentStatistics.vue